import React, { useMemo, useCallback } from 'react'
import uuid from 'uuid'

import S from './styled'

const Checkbox = ({ title = '', onChange, value, name, invertCheck, readOnly }) => {

  const id = useMemo(() => {
    return `${name}_${uuid()}`
  }, [name])

  const handleChange = useCallback(() => {
    !readOnly && onChange && onChange({
      target: {
        name,
        value: !value,
      },
    })
  },[name, onChange, readOnly, value])

  return (
    <S.Checkbox readOnly={readOnly}>
      <input
        id={id}
        type="checkbox"
        onChange={handleChange}
        checked={invertCheck ? !value : value}
        name={name}
        readOnly={readOnly}
        disabled={readOnly}
      />
      <span className="check" onClick={handleChange}></span>
      {title && <label htmlFor={id}>{title}</label>}
    </S.Checkbox>
  )
}

export default Checkbox
